import { TranslationKeys } from '@nimbus-library/features/localization/models/enums/translation-keys.enum';

export interface ITaskTab {
  id: string;
  name: TranslationKeys;
  isActive: boolean;
  isVisible: boolean;
}

export const TASK_TAB_CODES = 'codes';
export const TASK_TAB_FLOW = 'flow';
export const TASK_TAB_CONTEXT = 'context';

export const TASK_TABS = [
  { id: TASK_TAB_CODES, name: TranslationKeys.CallTabsCodes, isActive: false, isVisible: true },
  { id: TASK_TAB_FLOW, name: TranslationKeys.CallTabsFlow, isActive: true, isVisible: true },
  { id: TASK_TAB_CONTEXT, name: TranslationKeys.CallTabsContext, isActive: false, isVisible: true },
];

export const ASSISTANT_EXTENDED_TOAST_TABS_FLOW = [
  { id: TASK_TAB_FLOW, name: TranslationKeys.CallTabsFlow, isActive: true, isVisible: true },
];

export const ASSISTANT_EXTENDED_TOAST_TABS_CONTEXT = [
  { id: TASK_TAB_CONTEXT, name: TranslationKeys.CallTabsContext, isActive: true, isVisible: true },
];
